import { Injectable } from '@angular/core';
import {
    HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { AppStateService } from '@app/shared/services/app-state.service';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    API_URL = environment.API_ENDPOINT;
    constructor(private router: Router, private appState: AppStateService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        if (window.sessionStorage.getItem('userDetails') != null && window.sessionStorage.getItem('userDetails') !='null') {
            const token = JSON.parse(window.sessionStorage.getItem('userDetails')).accessToken
                === undefined ? '' : JSON.parse(window.sessionStorage.getItem('userDetails')).accessToken;
            if (token) {
                req = req.clone({ headers: req.headers.set('Authorization', token) });
            }
            if (JSON.parse(window.localStorage.getItem('logoutStatus')) && window.sessionStorage.getItem('userDetails')) {
                window.sessionStorage.clear();
                this.appState.setState(false);
                this.router.navigate(['/signin']);
            }
        }
        else{
            window.sessionStorage.removeItem('userDetails');
        }
        if (window.localStorage.getItem('userDetails') && window.sessionStorage.getItem('userDetails')) {
            const token = JSON.parse(window.localStorage.getItem('userDetails')).accessToken
                === undefined ? '' : JSON.parse(window.localStorage.getItem('userDetails')).accessToken;
            if (token) {
                req = req.clone({ headers: req.headers.set('Authorization', token) });
            }

            if (JSON.parse(window.localStorage.getItem('logoutStatus'))) {
                this.appState.setState(false);
                this.router.navigate(['/signin']);
            }
        }

        if (!req.headers.has('Content-Type')) {
            req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
        }
        // setting the accept header
        if (req.url.indexOf("ibm") > 0 ) {
            req = req.clone({ headers: req.headers.set('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8') });
            req = req.clone({ headers: req.headers.set('Accept', 'text/xml') });
            req = req.clone({ headers: req.headers.set('Access-Control-Allow-Origin', '*') });
            req = req.clone({
                url: `${req.url}`,
            });
        } else  if (req.url.indexOf("wordpress.perfomatix.online") > 0 ) {
            req = req.clone({ headers: req.headers.set('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8') });
            req = req.clone({ headers: req.headers.set('Accept', 'text/xml') });
            req = req.clone({ headers: req.headers.set('Access-Control-Allow-Origin', '*') });
            req = req.clone({
                url: `${req.url}`,
            });
        }
         else if (req.url.indexOf("assets") >= 0) {
            req = req.clone({ headers: req.headers.set('Accept', 'text/xml') });
            req = req.clone({
                url: `${req.url}`,
         });
        } else {
            req = req.clone({ headers: req.headers.set('Accept', 'application/json') });
        req = req.clone({
            url: `${this.API_URL}${req.url}`,
        });
    }
        return next.handle(req);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/http-interceptors/auth-interceptor.ts